export const Field = ({ children }) => (
  <span style={{ borderBottom: '1px solid grey' }}>{children}</span>
);
